import { Base } from "./base";

export class SensorTransaction extends Base {
    SensorTransactionID: string;
    SensorID: string;
    Date: Date;
    IsOccupied: boolean;

    // Model properties
    Sensor: string;
    ModelDate: string;
}